import React, { useState } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import i18n from 'i18next'

const LanguageSelector = () => {
  const { activeLanguage, updateLanguage } = useLanguage()
  const [showFlags, setShowFlags] = useState(false)

  const handleLanguageChange = (lang) => {
    updateLanguage(lang)
    i18n.changeLanguage(lang)
    setShowFlags(false) // Hide flags after selection
  }

  const toggleFlags = () => {
    setShowFlags(!showFlags)
  }

  const renderFlags = () => {
    if (showFlags) {
      return (
        <div className="flag-container vertical">
          {activeLanguage !== 'fr' && (
            <span
              onClick={() => handleLanguageChange('fr')}
              className="flag_icon"
            >
              <img src="/images/icons/flag_fr_icon_24.png" alt="Français" />
            </span>
          )}
          {activeLanguage !== 'en' && (
            <span
              onClick={() => handleLanguageChange('en')}
              className="flag_icon"
            >
              <img src="/images/icons/flag_en_icon_24.png" alt="English" />
            </span>
          )}
          {activeLanguage !== 'es' && (
            <span
              onClick={() => handleLanguageChange('es')}
              className="flag_icon"
            >
              <img src="/images/icons/flag_es_icon_24.png" alt="Español" />
            </span>
          )}
        </div>
      )
    }
  }

  return (
    <div className="language-selector-wrapper position-relative">
      <div className={`language-selector ${showFlags ? 'expanded' : ''}`}>
        <span
          onClick={toggleFlags}
          className={`flag_icon ${showFlags ? 'flag_icon_active' : ''}`}
        >
          <img
            src={`/images/icons/flag_${activeLanguage}_icon_24.png`}
            alt={
              activeLanguage === 'fr'
                ? 'Français'
                : activeLanguage === 'en'
                ? 'English'
                : 'Español'
            }
          />
        </span>
        {renderFlags()}
      </div>
    </div>
  )
}

export default LanguageSelector
